<template>
  <div class='EnbEditProfile'>
    <enb-title-page text="Editar informações pessoais"/>
    <input-reg
    :value="SelectedClientEdit.usuario.nome"
    @update:model-value="newValue => ChangeClientEdit({ usuario: { nome: newValue } })"
    text="Nome"
    :cont="{ width: '60%', margin: 'auto' }"
    :label="{ textAlign: 'left', marginLeft: '2%', marginTop: '5px' }"
    :input="{ fontSize: '20px', padding: '1.5%', width: '94%', borderRadius: '5px' }"
    :error="EditClientValidate.nome.$invalid"
    />
    <input-reg
    :value="SelectedClientEdit.usuario.sobrenome"
    @update:model-value="newValue => ChangeClientEdit({ usuario: { sobrenome: newValue } })"
    text="Sobrenome"
    :cont="{ width: '60%', margin: 'auto' }"
    :label="{ textAlign: 'left', marginLeft: '2%', marginTop: '5px' }"
    :input="{ fontSize: '20px', padding: '1.5%', width: '94%', borderRadius: '5px' }"
    :error="EditClientValidate.sobrenome.$invalid"
    />
    <div style="display: flex; justify-content: center; width: 60%; margin: auto;">
      <input-reg
      :value="SelectedClientEdit.endereco.cpf"
      @update:model-value="newValue => ChangeClientEdit({ endereco: { cpf: newValue } })"
      text="CPF"
      :cont="{ width: '48.5%' }"
      :label="{ textAlign: 'left', marginLeft: '2%', marginTop: '5px' }"
      :input="{ fontSize: '20px', padding: '2.5%', width: '95%', borderRadius: '5px' }"
      :Mask="['###.###.###-##']"
      :error="EditClientValidate.cpf.$invalid"
      />
      <input-reg
      :value="SelectedClientEdit.endereco.cep"
      @update:model-value="newValue => getEndereco(newValue)"
      text="CEP"
      :cont="{ width: '47%', paddingLeft: '2%' }"
      :label="{ textAlign: 'left', marginLeft: '2%', marginTop: '5px' }"
      :input="{ fontSize: '20px', padding: '2.5%', width: '95%', borderRadius: '5px' }"
      :Mask="['#####-###']"
      :error="EditClientValidate.cep.$invalid"
      />
    </div>
    <div>
      <input-reg
      :value="SelectedClientEdit.endereco.endereco"
      @update:model-value="newValue => ChangeClientEdit({ endereco: { endereco: newValue } })"
      text="Endereço"
      :cont="{ width: '60%', margin: 'auto' }"
      :label="{ textAlign: 'left', marginLeft: '2%', marginTop: '5px' }"
      :input="{ fontSize: '20px', padding: '1.5%', width: '94%', borderRadius: '5px' }"
      disabled
      :error="EditClientValidate.endereco.$invalid"
      />
    </div>
    <div style="display: flex; justify-content: center; width: 60%; margin: auto;">
      <input-reg
      :value="SelectedClientEdit.endereco.bairro"
      @update:model-value="newValue => ChangeClientEdit({ endereco: { bairro: newValue } })"
      text="Bairro"
      :cont="{ width: '48.5%' }"
      :label="{ textAlign: 'left', marginLeft: '2%', marginTop: '5px' }"
      :input="{ fontSize: '20px', padding: '2.5%', width: '95%', borderRadius: '5px' }"
      disabled
      :error="EditClientValidate.bairro.$invalid"
      />
      <input-reg
      :value="SelectedClientEdit.endereco.numero"
      @update:model-value="newValue => ChangeClientEdit({ endereco: { numero: newValue } })"
      text="Número"
      :cont="{ width: '47%', paddingLeft: '2%' }"
      :label="{ textAlign: 'left', marginLeft: '2%', marginTop: '5px' }"
      :input="{ fontSize: '20px', padding: '2.5%', width: '95%', borderRadius: '5px' }"
      :Mask="['########']"
      :error="EditClientValidate.numero.$invalid"
      />
    </div>
    <div>
      <input-reg
      :value="SelectedClientEdit.endereco.cidade"
      @update:model-value="newValue => ChangeClientEdit({ endereco: { cidade: newValue } })"
      text="Cidade"
      :cont="{ width: '60%', margin: 'auto' }"
      :label="{ textAlign: 'left', marginLeft: '2%', marginTop: '5px' }"
      :input="{ fontSize: '20px', padding: '1.5%', width: '94%', borderRadius: '5px' }"
      disabled
      :error="EditClientValidate.cidade.$invalid"
      />
    </div>
    <div style="display: flex; justify-content: center; width: 60%; margin: auto;">
      <input-reg
      :value="SelectedClientEdit.endereco.uf"
      @update:model-value="newValue => ChangeClientEdit({ endereco: { uf: newValue } })"
      text="Estado(UF)"
      :cont="{ width: '48.5%' }"
      :label="{ textAlign: 'left', marginLeft: '2%', marginTop: '5px' }"
      :input="{ fontSize: '20px', padding: '2.5%', width: '95%', borderRadius: '5px' }"
      :Mask="['AA']"
      disabled
      :error="EditClientValidate.uf.$invalid"
      />
      <input-reg
      :value="SelectedClientEdit.endereco.celular"
      @update:model-value="newValue => ChangeClientEdit({ endereco: { celular: newValue } })"
      text="Celular"
      :cont="{ width: '47%', paddingLeft: '2%' }"
      :label="{ textAlign: 'left', marginLeft: '2%', marginTop: '5px' }"
      :input="{ fontSize: '20px', padding: '2.5%', width: '95%', borderRadius: '5px' }"
      :Mask="['(##) #####-####', '(##) ####-####']"
      :error="EditClientValidate.celular.$invalid"
      />
    </div>
    <div style="display: flex; justify-content: end; width: 59%; margin: auto; padding: 1%;">
      <button
      :style="{
        backgroundColor: Prefes.btn.corBackground,
        color: Prefes.btn.corFont,
        fontFamily: Prefes.btn.font,
        fontStyle: parseInt(Prefes.btn.fontStyle) ? 'italic' : '',
        fontWeight: parseInt(Prefes.btn.fontBold) ? 'bold' : '',
        textDecoration: parseInt(Prefes.btn.textDecoration) ? 'underline' : '',
        fontSize: Prefes.btn.fontHeight + 'px'
      }"
      @click="Upload"
      :disabled="load"
      >
        <label v-if="!load">Salvar</label>
        <component
        :is="Prefes.spinner.tipo"
        :color="Prefes.btn.corFont"
        :size="Prefes.spinner.tipo === 'EnbSyncLoader' ? '12px' : '40px'"
        style="z-index: 999"
        v-if="load"
        />
      </button>
    </div>
    <div style="width: 100%; height: 50px;"></div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import InputReg from '@/components/EnbPainel/Produtos/Register/InputReg'
import EnbTitlePage from '@/components/EnbTitlePage'
import { useVuelidate } from '@vuelidate/core'
import { required, minLength } from '@vuelidate/validators'
import { loaders } from '@/components/Spinner'
export default {
  name: 'EnbEditProfile',
  setup () {
    return { v$: useVuelidate() }
  },
  components: { InputReg, EnbTitlePage, ...loaders },
  data () {
    return {
      load: false
    }
  },
  computed: {
    ...mapGetters(['SelectedClientEdit', 'Prefes', 'EditClientValidate']),
    nome () {
      return this.SelectedClientEdit.usuario.nome
    },
    sobrenome () {
      return this.SelectedClientEdit.usuario.sobrenome
    },
    cpf () {
      return this.SelectedClientEdit.endereco.cpf
    },
    celular () {
      return this.SelectedClientEdit.endereco.celular
    },
    cep () {
      return this.SelectedClientEdit.endereco.cep
    },
    bairro () {
      return this.SelectedClientEdit.endereco.bairro
    },
    endereco () {
      return this.SelectedClientEdit.endereco.endereco
    },
    numero () {
      return this.SelectedClientEdit.endereco.numero
    },
    cidade () {
      return this.SelectedClientEdit.endereco.cidade
    },
    uf () {
      return this.SelectedClientEdit.endereco.uf
    }
  },
  methods: {
    ...mapActions(['ChangeClientEdit', 'getApiCep', 'setEditClientValidate', '_UpdateInfoClient']),
    getEndereco (cep) {
      if (cep.length === 9) {
        this.getApiCep(cep.replace('-', ''))
          .then((data) => {
            this.ChangeClientEdit({
              endereco: {
                bairro: data.bairro,
                endereco: data.logradouro,
                cidade: data.localidade,
                uf: data.uf
              }
            })
          })
      }
      this.ChangeClientEdit({ endereco: { cep: cep } })
    },
    async Upload () {
      this.load = true
      let valid = await this.v$.$validate()
      if(!valid) {
        this.setEditClientValidate(this.v$)
        this.load = false
        return
      }
      this._UpdateInfoClient(this.SelectedClientEdit)
        .then(() => {
          localStorage.setItem('client', JSON.stringify(this.SelectedClientEdit))
          this.load = false
        })
    }
  },
  validations () {
    return {
      nome: {
        required
      },
      sobrenome: {
        required
      },
      cpf: {
        required,
        minLength: minLength(14)
      },
      celular: {
        required,
        minLength: minLength(15)
      },
      cep: {
        required,
        minLength: minLength(9)
      },
      bairro: {
        required
      },
      endereco: {
        required
      },
      numero: {
        required
      },
      cidade: {
        required
      },
      uf: {
        required,
        minLength: minLength(2)
      }
    }
  }
}
</script>

<style scoped>
.EnbEditProfile {
  width: 100%;
}
button {
  border: 0;
  background-color: #000000;
  border-radius: 5px;
  padding: 1.3%;
  color: #FFFFFF;
  cursor: pointer;
}
</style>
